import Model from "../Model";

class ComercialbubbledetailUser extends Model{

    buildUrl ({ param }) {
        return ['zoneview/detailsbyuserid', param];
    }

    all(config = {}) {
        return this.request({ method: 'POST', action: 'all', ...config });
    }
}


export default new ComercialbubbledetailUser;